<template>
  <el-dialog
    :title="title"
    :visible.sync="expressDeliveryDialogVisible"
    width="30%"
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="120px"
    >
      <el-form-item label="回寄快递单号" prop="returnExpressNumber">
        <el-input v-model="formData.returnExpressNumber"></el-input>
      </el-form-item>

      <el-form-item label="回寄快递公司" prop="returnExpressCompany">
        <el-input v-model="formData.returnExpressCompany"></el-input>
      </el-form-item>

      <el-form-item
        label="交接财务日期:"
        prop="returnHandoverFinanceDate"
        class="t-left"
      >
        <el-date-picker
          v-model="formData.returnHandoverFinanceDate"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="上传交接照片" prop="returnHandoverPhotoJson">
        <el-upload
          class="upload-demo t-left"
          v-model="formData.returnHandoverPhotoJson"
          action="#"
          multiple
          :limit="3"
          accept=".jpg,.png,.jpeg"
          :on-exceed="handleExceed"
          :on-remove="handleFileRemove"
          :http-request="uploadFile"
          :file-list="formData.returnHandoverPhotoJson"
          :beforeUpload="beforeAvatarUpload"
        >
          <el-button
            size="mini"
            icon="el-icon-my-import"
            style="margin-top: 8px; margin-bottom: 0"
            type="importNew"
            >导入文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            支持.jpg,.png,.jpeg文件，单个文件不得大于5M
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button
          type="info"
          class="w100f"
          :loading="btnLoading"
          @click="onSubmit"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["title", "onChangeFullscreenLoading", "getList"],
  data() {
    return {
      fileUrl: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
      expressDeliveryDialogVisible: false,
      formData: {
        returnExpressNumber: "",
        returnExpressCompany: "",
        returnHandoverFinanceDate: "",
        returnHandoverPhotoJson: [],
        guid: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      btnLoading: false,
      rules: {
        // 快递单号
        returnExpressNumber: [
          { required: true, message: "请输入快递单号" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "仅可输入英文和数字",
            trigger: "blur",
          },
        ],
        // 快递公司
        returnExpressCompany: [
          { required: true, message: "请输入快递公司" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        returnHandoverFinanceDate: [
          { required: true, message: "请选择交接财务日期" },
        ],
        returnHandoverPhotoJson: [
          { required: true, message: "请上传交接照片" },
        ],
      },
    };
  },
  methods: {
    open(data) {
      this.expressDeliveryDialogVisible = true;
      this.formData = data;
    },
    async onSubmit() {
      const validateForm = () => {
        return new Promise((resolve, reject) => {
          this.$refs.formData.validate((valid) => {
            if (valid) resolve(true);
            else reject(new Error("表单验证失败"));
          });
        });
      };
      await validateForm();

      const returnHandoverPhotoJson = this.formData.returnHandoverPhotoJson.map(
        (item) => {
          return item?.path || item;
        }
      );
      const params = {
        ...this.formData,
        returnHandoverFinanceDate: this.$moment(
          this.formData.returnHandoverFinanceDate
        ).format("YYYY-MM-DD"),
        returnHandoverPhotoJson: JSON.stringify(returnHandoverPhotoJson),
      };
      this.btnLoading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/contract/update-return-info`,
        params
      );
      this.btnLoading = false;
      this.expressDeliveryDialogVisible = false;
      if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message({
          message: "上传成功",
          type: "success",
        });
      } else {
        this.$message.error(data.msg);
      }
      this.getList();
    },
    //上传限制
    beforeAvatarUpload(file) {
      const maxSize = file.size / 1024 / 1024 < 5;
      if (!maxSize) {
        this.$message({
          message: `上传文件大小不能超过 5MB!`,
          type: "warning",
        });
      }
      return maxSize;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //移除文件
    handleFileRemove(file) {
      this.formData.returnHandoverPhotoJson.forEach((i, index) => {
        if (i.path == file.path) {
          this.formData.returnHandoverPhotoJson.splice(index, 1);
        }
      });
    },
    //上传文件
    uploadFile(file) {
      this.onChangeFullscreenLoading(true);
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("fileName", file.file.name);
      this.api
        .postImage(this.fileUrl, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              path: res.data.data.data,
            };
            this.formData.returnHandoverPhotoJson.push(item);
            this.onChangeFullscreenLoading(false);
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.formData.returnHandoverPhotoJson = [];
            this.$message.error("上传失败!");
          }
        })
        .catch(() => {
          this.$message("上传失败！");
        });
    },
  },
};
</script>

<style></style>
